import React, {useEffect, useState} from 'react';
import { Button } from 'react-bootstrap';
import ReactCardFlip from 'react-card-flip';

import { BodyMaleFront, BodyMaleBack } from './';

const levels = ['white','yellow','orange','red'];

const intitialAreas = {
    front: {
        leftHead: levels[0],
        rightHead: levels[0],
        leftFace: levels[0],
        rightFace: levels[0],
        leftNeck: levels[0],
        rightNeck: levels[0],
        leftShoulder: levels[0],
        rightShoulder: levels[0],
        leftChest: levels[0],
        rightChest: levels[0],
        leftAbdomen: levels[0],
        rightAbdomen: levels[0],
        leftGroin: levels[0],
        rightGroin: levels[0],
        leftUpperLeg: levels[0],
        rightUpperLeg: levels[0],
        leftKnee: levels[0],
        rightKnee: levels[0],
        leftFoot: levels[0],
        rightFoot: levels[0],
        rightAnkle: levels[0],
        leftAnkle: levels[0],
        leftLowerLeg: levels[0],
        rightLowerLeg: levels[0],
        leftUpperArm: levels[0],
        rightUpperArm: levels[0],
        leftLowerArm: levels[0],
        rightLowerArm: levels[0],
        leftWrist: levels[0],
        rightWrist: levels[0],
        leftHand: levels[0],
        rightHand: levels[0],
        leftElbow: levels[0],
        rightElbow: levels[0],
        leftHip: levels[0],
        rightHip: levels[0]
    },
    back: {
        leftHead: levels[0],
        rightHead: levels[0],
        leftFace: levels[0],
        rightFace: levels[0],
        leftNeck: levels[0],
        rightNeck: levels[0],
        leftShoulder: levels[0],
        rightShoulder: levels[0],
        leftBack: levels[0],
        rightBack: levels[0],
        leftUpperBack: levels[0],
        rightUpperBack: levels[0],
        leftLowerBack: levels[0],
        rightLowerBack: levels[0],
        leftButtock: levels[0],
        rightButtock: levels[0],
        leftUpperLeg: levels[0],
        rightUpperLeg: levels[0],
        leftKnee: levels[0],
        rightKnee: levels[0],
        leftFoot: levels[0],
        rightFoot: levels[0],
        rightAnkle: levels[0],
        leftAnkle: levels[0],
        leftLowerLeg: levels[0],
        rightLowerLeg: levels[0],
        leftUpperArm: levels[0],
        rightUpperArm: levels[0],
        leftLowerArm: levels[0],
        rightLowerArm: levels[0],
        leftWrist: levels[0],
        rightWrist: levels[0],
        leftHand: levels[0],
        rightHand: levels[0],
        leftElbow: levels[0],
        rightElbow: levels[0],
        leftHip: levels[0],
        rightHip: levels[0],
    }
}

const SVG_MAP = (props) => {
    const { isSingle, onAnswer, questionIndex, answers } = props;
    const [ selected, setSelected ] = useState(null);
    const [ areas, setAreas ] = useState(intitialAreas);

    useEffect(() => {
        if (isSingle) {
            setAreas(intitialAreas);

            if (selected) {
                setAreas({
                    ...intitialAreas,
                    [selected.side]: {
                        ...intitialAreas[selected.side],
                        [selected.location]: selected.level
                    }
                })
            }
        }
    }, [selected])

    const handleAnswer = (side, area, painLevel) => {
        var tmp = [];
        answers[questionIndex].forEach(item => {
            if (!item.includes(`side: ${side}, area: ${area}`)) {
                tmp.push(item);
            }
        });
        if (painLevel !== 0) {
            tmp.push(`{side: ${side}, area: ${area}, painLevel: ${painLevel}}`);
        }
        onAnswer(tmp, questionIndex);
    }

    const onClick = (side, location) => {
        switch(areas[side][location]) {
            case levels[0]:
                setAreas({
                    ...areas,
                    [side]: {
                        ...areas[side],
                        [location]: levels[1]
                    }
                })
                if (onAnswer) {
                    handleAnswer(side, location, 1);
                }
                setSelected({side, location, level: levels[1]});
                break;
            case levels[1]:
                setAreas({
                    ...areas,
                    [side]: {
                        ...areas[side],
                        [location]: levels[2]
                    }
                })
                if (onAnswer) {
                    handleAnswer(side, location, 2);
                }
                setSelected({side, location, level: levels[2]});
                break;
            case levels[2]:
                setAreas({
                    ...areas,
                    [side]: {
                        ...areas[side],
                        [location]: levels[3]
                    }
                })
                if (onAnswer) {
                    handleAnswer(side, location, 3);
                }
                setSelected({side, location, level: levels[3]});
                break;
            case levels[3]:
                setAreas({
                    ...areas,
                    [side]: {
                        ...areas[side],
                        [location]: levels[0]
                    }
                })
                if (onAnswer) {
                    handleAnswer(side, location, 0);
                }
                setSelected(null);
                break;
            default:
                return;
        }
    }

    const svgProps = { onClick, areas };

    return (
        <div className="bodymap-container">
            <div className="bodymap-front">
                <BodyMaleFront {...svgProps} height={350} />
            </div>
            <div className="bodymap-back">
                <BodyMaleBack {...svgProps} height={350} />
            </div>
        </div>
    )
}

export default SVG_MAP;